import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-simple-page-hero/jb-simple-page-hero.css.ts
var jb_simple_page_hero_css_default = i`h1{font-family:var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}h1{color:rgb(var(--rgb-primary, 20, 30, 85));font-size:1.625rem;line-height:2.188rem}@media(min-width: 1281px){h1{font-size:1.938rem;line-height:2.625rem}}:host{display:block}@media(min-width: 1281px){:host{padding:40px 0 20px}}h1{margin-bottom:16px;text-align:center}`;

export {
  jb_simple_page_hero_css_default
};
